import { render, staticRenderFns } from "./PaymentIssue.vue?vue&type=template&id=0c198034&scoped=true&"
import script from "./PaymentIssue.vue?vue&type=script&lang=ts&"
export * from "./PaymentIssue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c198034",
  null
  
)

export default component.exports